import React from 'react';

import {useStore} from 'effector-react';

import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';

import {ReactComponent as Success} from 'assets/svg/batch-number-success.svg';
import {ReactComponent as CopyIcon} from 'assets/svg/copy.svg';
import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Icon} from 'components/ui-kit/Icon';
import {Input} from 'components/ui-kit/Input';
import {Modal} from 'components/ui-kit/Modal';
import {batchNumberModal$, showBatchNumberModal, utilisationForm$} from 'models/documents/create';

import {useClipboard} from 'utils/custom-hooks';

import {Logo, Root, TextBody, TextHeadline, TextWrapper} from './styled';

export const BatchNumberModal = () => {
    const show = useStore(batchNumberModal$);
    const {t} = useTranslation();
    const onClose = () => showBatchNumberModal(false);
    const batchNumber = useStore(utilisationForm$);
    const copy = useClipboard();

    return (
        <Modal closable={false} hideCloseButton modalWidth={0} show={show} onClose={onClose}>
            <Root>
                <Logo>
                    <Icon source={Success} width={32} height={32} fillColor={'transparent'} />
                </Logo>
                <TextWrapper>
                    <TextHeadline>
                        {t('pages.documents.invoices.create.batchNumberModal.title')}
                    </TextHeadline>
                    <TextBody>
                        {t('pages.documents.invoices.create.batchNumberModal.body')}
                    </TextBody>
                </TextWrapper>
                <Input
                    style={{height: 68, fontSize: 16}}
                    placeholder={t('pages.documents.invoices.create.batchNumberModal.placeholder')}
                    value={batchNumber.batchNumber}
                    disabled
                    adornment={
                        <Button
                            variant={ButtonVariant.Normal}
                            size={'sm'}
                            onClick={() => {
                                copy(batchNumber.batchNumber || '');
                                toast.success(
                                    t('pages.documents.invoices.create.batchNumberModal.success'),
                                );
                            }}
                        >
                            <Icon
                                style={{marginRight: 8}}
                                source={CopyIcon}
                                width={16}
                                height={16}
                                fillColor={'white'}
                            />
                            {t('pages.documents.invoices.create.batchNumberModal.copy')}
                        </Button>
                    }
                />
                <TextBody>
                    {t('pages.documents.invoices.create.batchNumberModal.description')}
                </TextBody>
                <Button onClick={onClose}>
                    {t('pages.documents.invoices.create.batchNumberModal.continue')}
                </Button>
            </Root>
        </Modal>
    );
};
